export const DEPENDENTS_AREA = {
  LABEL: 'personal.dependant',
  DEPENDENTS: '7e04b405-747c-4e7e-a575-44f1feb34e71',
}
